<template>
    <div class="sistema-section">
        <div class="sistema-content">
            <h2 class="sistema-title fuente-posm">
                Crea un Sistema<br>
                <span>Acorde a tu Marca</span>
            </h2>
            <p class="sistema-text fuente-nova">
                Deja atrás los programas genéricos de puntos. Con Efisense Rewards creamos un sistema de lealtad personalizado para tu negocio, con tu marca, tus reglas y tus recompensas.
                <br><br>
                Fideliza clientes, incrementa visitas repetidas y construye relaciones duraderas, todo desde una plataforma pensada para crecer contigo.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SistemaMarcaRewardNew'
}
</script>

<style lang="css" scoped>
.sistema-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
}

.sistema-content {
    max-width: 700px;
    margin-left: 10%;
}

.sistema-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.sistema-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .sistema-title {
        font-size: 60px;
    }

    .sistema-text {
        font-size: 27px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .sistema-section {
        justify-content: center;
        align-items: flex-start;
        padding: 100px 20px 40px 20px;
    }

    .sistema-content {
        margin-left: 0;
        max-width: 100%;
        flex: none;
    }

    .sistema-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .sistema-text {
        font-size: 16px;
        padding-left: 10px;
    }
}
</style>
